<script setup lang="ts">
import type { NovaBoxEmptyMessageProps } from './NovaBoxEmptyMessage.types'
import EmptyImageIllustration from 'assets/images/empty-image-illustration.png'

withDefaults(defineProps<NovaBoxEmptyMessageProps>(), {
  title: '',
  fill: false,
  fillMax: false,
  theme: 'icon',
  box: false,
  actions: () => [],
})
</script>

<template>
  <div :class="['empty-message-wrap', { fill, fillMax, box }]">
    <NovaIcon
      v-if="theme === 'icon'"
      :icon="{ type: 'outline', name: 'search-fail' }"
      :size="30"
      class="icon"
    />

    <img
      v-if="theme === 'illustration'"
      :src="EmptyImageIllustration"
      alt=""
      class="illustration"
    />

    <div class="contents">
      <h4 v-if="title" v-dompurify-html="title" class="title" />
      <p v-dompurify-html="message" class="message" />
    </div>

    <div
      v-if="actions.length"
      :class="['grid-wrapper', `grid-${actions.length}`, 'gap-4']"
    >
      <NovaButtonText
        v-for="(item, index) in actions"
        v-bind="item"
        :key="index"
        :full-width="true"
        @click="item.action"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.empty-message-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: auto;
  min-height: 120px;
  padding: 16px;

  &.fill {
    flex-grow: 1;
    height: 100%;
    min-height: 260px;
  }

  &.fillMax {
    flex-grow: 1;
    height: 100%;
    min-height: 600px;
  }

  &.box {
    border-radius: $radius-10;
    background-color: $color-bg-3;
  }

  > .icon {
    color: $color-text-3;
  }

  > .illustration {
    width: 48px;
    height: auto;
  }

  .contents {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .title {
      @include text-style($text-display-regular);
      color: $color-text-1;
      text-align: center;
      word-break: keep-all;
    }

    .message {
      @include text-style($text-body-14-regular);
      color: $color-text-3;
      text-align: center;
      word-break: keep-all;
    }
  }

  .actions {
  }
}
</style>
